module.exports = __webpack_public_path__ + "assets/img/banner.f2189855.png";